export enum FacebookReactionType {
    smile = 1,
    angry = 2,
    sad = 3,
    wow = 4,
    love = 5,
    like = 6,
    dislike = 7,
    haha = 8,
    sorry = 9,
    other = 10,
}
